import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import { AuthContext } from '@/App';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { toast } from 'sonner';

const API = '/api';

export default function LoginPage() {
  const navigate = useNavigate();
  const { login } = React.useContext(AuthContext);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(`${API}/auth/login`, {
        email,
        password
      });

      login(response.data.access_token, response.data.user);
      toast.success('Tekrar hoş geldiniz!');
      navigate('/dashboard');
    } catch (error) {
      console.error('Login error:', error);
      toast.error(error.response?.data?.detail || 'Giriş başarısız. Lütfen bilgilerinizi kontrol edin.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="curtain-bg min-h-screen flex items-center justify-center px-6 pt-48 pb-12">
      <div className="w-full max-w-md">
        <div className="glass-effect rounded-2xl p-8 shadow-2xl">
          <div className="text-center mb-8">
            <div className="flex justify-center items-center mb-4">
              <img src="/onk-logo.png" alt="ONK Ajans" style={{ width: '175px', height: 'auto' }} />
            </div>
            <h1 
              className="text-3xl font-bold gold-glow mb-2"
              data-testid="login-title"
            >
              Tekrar Hoş Geldiniz
            </h1>
            <p className="text-gray-400 text-base">Hesabınıza giriş yapın</p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6" data-testid="login-form">
            <div className="space-y-2">
              <Label htmlFor="email" className="text-gray-300">E-posta</Label>
              <Input
                id="email"
                type="email"
                placeholder="ornek@email.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="bg-black/30 border-amber-800/40 text-white focus:border-amber-600 placeholder:text-[#7a7978]"
                data-testid="login-email-input"
              />
            </div>

            <div className="space-y-2">
              <Label htmlFor="password" className="text-gray-300">Şifre</Label>
              <Input
                id="password"
                type="password"
                placeholder="••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="bg-black/30 border-amber-800/40 text-white focus:border-amber-600 placeholder:text-[#7a7978]"
                data-testid="login-password-input"
              />
            </div>

            <Button
              type="submit"
              className="w-full bg-[#c50605] hover:bg-[#9d0504] text-white py-6 text-base"
              disabled={loading}
              data-testid="login-submit-btn"
            >
              {loading ? 'Giriş yapılıyor...' : 'Giriş Yap'}
            </Button>
          </form>

          <div className="mt-6 text-center">
            <Button
              onClick={() => navigate('/register')}
              className="w-full bg-[#c50605] hover:bg-[#9d0504] text-white py-6 text-base"
              data-testid="login-register-btn"
            >
              Hesap Oluştur
            </Button>
          </div>

          <div className="mt-4 text-center">
            <Link to="/" className="text-white hover:text-gray-300 text-sm" data-testid="login-back-link">
              ← Ana sayfaya dön
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}